export enum ReportPeriod {
  Daily = 1,
  Monthly = 2
}
